import { Component, EventEmitter, Injector, Input, OnInit, Output, input } from '@angular/core';

@Component({
  selector: 'app-custom-side-bar',
  templateUrl: './custom-side-bar.component.html',
  styleUrl: './custom-side-bar.component.scss'
})
export class CustomSideBarComponent implements OnInit {
  showFiller = false;
  @Input() component : any
  @Input() data : any
  @Input() triggerComponent : any
  @Input() title : string
  @Input() show : boolean = false
  @Output() onClick = new EventEmitter<any>();
  constructor(private injector: Injector){

  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }
  closeSideBar(){
    this.show = !this.show
  }
  dynamicComponentInjector(): Injector {
    return this.injector;
  }
}
